export default {"src":"/_next/static/media/video-circular-icon.71a62d7f.svg","height":139,"width":137,"blurWidth":0,"blurHeight":0};